import { z } from "zod";
import { ComponentRoleSchema } from "./component-role.js";
import { SurfaceTypeSchema } from "./surface-grammar.js";
export const RecipeSchema = z
    .object({
    recipeId: z.string().min(1),
    recipeVersion: z.string().min(1),
    strategyId: z.string().min(1),
    surfaceType: SurfaceTypeSchema,
    deterministicInputs: z.array(z.string().min(1)).default([]),
    outputRoles: z.array(ComponentRoleSchema).default([]),
    fallbackPolicy: z.string().min(1),
})
    .strict();
//# sourceMappingURL=recipe.js.map